/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';
import { SecurityHelper } from 'sarsaparilla';
import * as globals from '../constants/globals';
import { makeAsyncAction } from '../utils/async_utils';
import {
    POST_REVIEW_FLAG_FAILURE,
    POST_REVIEW_FLAG_START,
    POST_REVIEW_FLAG_SUCCESS,
} from '../constants/types';

export type flagRequest = {
    id?: string;
    reservation_id?: string;
    reason: string;
};

export const postReviewFlagEndpoint = () => `${globals.API_URL}/review/flag`;

const postReviewFlagApi = (data: flagRequest) => () =>
    axios.post(postReviewFlagEndpoint(), data, {
        headers: { Authorization: SecurityHelper.getAuthHeader() },
    });

export const postReviewFlag = makeAsyncAction(
    {
        startType: POST_REVIEW_FLAG_START,
        successType: POST_REVIEW_FLAG_SUCCESS,
        failureType: POST_REVIEW_FLAG_FAILURE,
    },
    postReviewFlagApi,
    true,
    'data'
);
